export { default as Banner1 } from './webp/banner-1.webp'

export { default as Logo } from './webp/logo.webp'

// Social
export { default as IcFacebookSvg } from './svg/ic-fb.svg'
export { default as IcGoogleSvg } from './svg/ic-gg.svg'
export { default as IcXSvg } from './svg/ic-x.svg'
export { default as IcLinkedInSvg } from './svg/ic-linkedin.svg'
export { default as IcAppleSvg } from './svg/ic-apple.svg'

export { default as BannerMyJobs } from './webp/banner-my-jobs.webp'

export { default as StaffSvg } from './svg/staff.svg'
